import type { ReactNode } from 'react';

export interface TrailStep { label: ReactNode; sub?: ReactNode; state: 'done' | 'cur' | 'todo' }

/** Trilha de status vertical (C-27) — ex.: questionamento recebido → em análise → resolvido (T-17/T-59). */
export default function StatusTrail({ steps }: { steps: TrailStep[] }) {
  return (
    <ol className="status-trail" aria-label="Andamento">
      {steps.map((s, i) => (
        <li key={i} className={s.state} aria-current={s.state === 'cur' ? 'step' : undefined}>
          <span className="dot" aria-hidden>{s.state === 'done' ? '✓' : i + 1}</span>
          <div><b>{s.label}</b>{s.sub && <span>{s.sub}</span>}</div>
        </li>
      ))}
    </ol>
  );
}
